"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssignTrackerRequestT = exports.AssignTrackerRequest = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
const body_part_js_1 = require("../../solarxr-protocol/datatypes/body-part.js");
const tracker_id_js_1 = require("../../solarxr-protocol/datatypes/tracker-id.js");
const quat_js_1 = require("../../solarxr-protocol/datatypes/math/quat.js");
class AssignTrackerRequest {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsAssignTrackerRequest(bb, obj) {
        return (obj || new AssignTrackerRequest()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsAssignTrackerRequest(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new AssignTrackerRequest()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    trackerId(obj) {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? (obj || new tracker_id_js_1.TrackerId()).__init(this.bb.__indirect(this.bb_pos + offset), this.bb) : null;
    }
    bodyPosition() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.readUint8(this.bb_pos + offset) : body_part_js_1.BodyPart.NONE;
    }
    mountingOrientation(obj) {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? (obj || new quat_js_1.Quat()).__init(this.bb_pos + offset, this.bb) : null;
    }
    displayName(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 10);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    allowDriftCompensation() {
        const offset = this.bb.__offset(this.bb_pos, 12);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    static startAssignTrackerRequest(builder) {
        builder.startObject(5);
    }
    static addTrackerId(builder, trackerIdOffset) {
        builder.addFieldOffset(0, trackerIdOffset, 0);
    }
    static addBodyPosition(builder, bodyPosition) {
        builder.addFieldInt8(1, bodyPosition, body_part_js_1.BodyPart.NONE);
    }
    static addMountingOrientation(builder, mountingOrientationOffset) {
        builder.addFieldStruct(2, mountingOrientationOffset, 0);
    }
    static addDisplayName(builder, displayNameOffset) {
        builder.addFieldOffset(3, displayNameOffset, 0);
    }
    static addAllowDriftCompensation(builder, allowDriftCompensation) {
        builder.addFieldInt8(4, +allowDriftCompensation, +false);
    }
    static endAssignTrackerRequest(builder) {
        const offset = builder.endObject();
        return offset;
    }
    unpack() {
        return new AssignTrackerRequestT((this.trackerId() !== null ? this.trackerId().unpack() : null), this.bodyPosition(), (this.mountingOrientation() !== null ? this.mountingOrientation().unpack() : null), this.displayName(), this.allowDriftCompensation());
    }
    unpackTo(_o) {
        _o.trackerId = (this.trackerId() !== null ? this.trackerId().unpack() : null);
        _o.bodyPosition = this.bodyPosition();
        _o.mountingOrientation = (this.mountingOrientation() !== null ? this.mountingOrientation().unpack() : null);
        _o.displayName = this.displayName();
        _o.allowDriftCompensation = this.allowDriftCompensation();
    }
}
exports.AssignTrackerRequest = AssignTrackerRequest;
class AssignTrackerRequestT {
    constructor(trackerId = null, bodyPosition = body_part_js_1.BodyPart.NONE, mountingOrientation = null, displayName = null, allowDriftCompensation = false) {
        this.trackerId = trackerId;
        this.bodyPosition = bodyPosition;
        this.mountingOrientation = mountingOrientation;
        this.displayName = displayName;
        this.allowDriftCompensation = allowDriftCompensation;
    }
    pack(builder) {
        const trackerId = (this.trackerId !== null ? this.trackerId.pack(builder) : 0);
        const displayName = (this.displayName !== null ? builder.createString(this.displayName) : 0);
        AssignTrackerRequest.startAssignTrackerRequest(builder);
        AssignTrackerRequest.addTrackerId(builder, trackerId);
        AssignTrackerRequest.addBodyPosition(builder, this.bodyPosition);
        AssignTrackerRequest.addMountingOrientation(builder, (this.mountingOrientation !== null ? this.mountingOrientation.pack(builder) : 0));
        AssignTrackerRequest.addDisplayName(builder, displayName);
        AssignTrackerRequest.addAllowDriftCompensation(builder, this.allowDriftCompensation);
        return AssignTrackerRequest.endAssignTrackerRequest(builder);
    }
}
exports.AssignTrackerRequestT = AssignTrackerRequestT;
